import { DiscountCodeType } from "@/primary-models";

export enum NibblesDiscount {
  TWENTY_OFF = "TWENTY_OFF",
  FIFTY_OFF = "FIFTY_OFF",
}

export const NIBBLES_DISCOUNT_PRICE_MAP: Record<NibblesDiscount, {
  type: DiscountCodeType;
  amount: number;
}> = {
  [NibblesDiscount.TWENTY_OFF]: {
    type: DiscountCodeType.PERCENTAGE,
    amount: 20,
  },
  [NibblesDiscount.FIFTY_OFF]: {
    type: DiscountCodeType.PERCENTAGE,
    amount: 50,
  },
};
